/**
 * @file index.tsx
 *
 * @fileoverview Shows FAQ accordions.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OrganizationWidgetsBoxLabel } from '~/jobiqo/components/Organization/Widgets/BoxLabel';
import { EditLink } from '~/jobiqo/components/Organization/Widgets/EditLink';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Box } from '~/vcl/atoms/07-box';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';
import { Text } from '~/vcl/atoms/13-text/03-text';
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
} from '~/vcl/atoms/25-accordion';

interface OrganizationFAQWidgetViewProps {
  /**
   * The current organization profile.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string;
}

const OrganizationFAQWidgetView = ({
  organization,
  boxId,
}: OrganizationFAQWidgetViewProps) => {
  return (
    <Box
      label={
        <OrganizationWidgetsBoxLabel organization={organization} boxId={boxId}>
          <FormattedMessage
            id="faq_title"
            defaultMessage="Frequently asked questions"
          />
        </OrganizationWidgetsBoxLabel>
      }
    >
      <Spacing size="large" />
      <Accordion collapsible={true} multipleItems={true}>
        {organization.faq?.map((faq, index) => (
          <FlexItems
            key={faq?.id ?? index}
            gap={4}
            justifyContent="space-between"
          >
            <FlexItem flex={1}>
              <AccordionItem value={index.toString()}>
                <AccordionButton>
                  <Text tag="div" fontSize={3}>
                    {faq?.question?.label}
                  </Text>
                </AccordionButton>
                {faq?.answer && (
                  <AccordionPanel>
                    <WYSIWYGText format="full_html" content={faq.answer} />
                  </AccordionPanel>
                )}
              </AccordionItem>
            </FlexItem>
            {faq?.id && (
              <FlexItem>
                <EditLink
                  organization={organization}
                  boxId={boxId}
                  fieldIndex={Number(faq.id)}
                  boxHasTitle={true}
                />
              </FlexItem>
            )}
          </FlexItems>
        ))}
      </Accordion>
    </Box>
  );
};

export default OrganizationFAQWidgetView;
